import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import { HSpace } from "@examspark/common-ui";
import { colorFromTheme } from "@examspark/common-ui/dist/utils/color";
import { StyledCommonProps } from "@examspark/common-ui/dist/utils/styled";

const Styled = styled.div`
  background-color: ${colorFromTheme("surface0")};
  border-radius: 0.5rem;
  box-shadow: 0 0 0 1px ${colorFromTheme("surface5")};
  min-width: 25ch;

  &:first-child {
    margin-top: 0;
  }
`;
const Title = styled.h2`
  font-weight: 300;
  font-size: 1.7rem;
  line-height: 1.7rem;
  color: #555;
`;

export const EmptySidebarBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding: 1rem 3rem;
  height: 13rem;
  color: #999;
  font-size: 1.3rem;
  text-align: center;

  box-shadow: 0 0 0 1px ${colorFromTheme("surface5")};
  background-color: white;
  &:last-child {
    border-radius: 0 0 0.5rem 0.5rem;
  }

  svg {
    fill: #999;
    width: 3.2rem;
  }
`;

const Titlebar = styled.div`
  box-shadow: 0 0 0 1px ${colorFromTheme("surface5")};
  background-color: ${colorFromTheme("surface2")};
  border-radius: 0.5rem 0.5rem 0 0;
  padding: 0.9rem 1rem;
  display: flex;
  gap: 1rem;
  align-items: center;
  min-height: 4.8rem;
`;
const Toolbar = styled(HSpace)`
  flex: 1;
  justify-content: flex-end;
  gap: 0.5rem;
`;
const Footer = styled.div`
  border-top: solid 1px #ddd;
`;
const FooterButtons = styled.div`
  & button {
    border-top: solid 1px #ddd;
  }
  & button:first-child {
    border: none;
  }
  & button:last-child {
    border-radius: 0 0 0.5rem 0.5rem;
  }
`;

const SidebarBox: React.FC<
  React.PropsWithChildren<
    PropsWithChildren<
      StyledCommonProps & {
        title?: string;
        footer?: React.ReactNode;
        toolbar?: React.ReactNode;
      }
    >
  >
> & {
  FooterButtons: typeof FooterButtons;
} = (props) => {
  return (
    <Styled className={props.className}>
      {!!props.title && (
        <Titlebar>
          <Title>{props.title}</Title>
          {!!props.toolbar && <Toolbar>{props.toolbar}</Toolbar>}
        </Titlebar>
      )}
      {props.children}
      {!!props.footer && <Footer>{props.footer}</Footer>}
    </Styled>
  );
};

SidebarBox.FooterButtons = FooterButtons;

export default SidebarBox;
